import { z } from 'zod';

export const PlanningAlgorithmCardSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z
    .string()
    .min(1, { message: 'Укажите название' })
    .max(200, { message: 'Не более 200 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  description: z.string().max(300, { message: 'Не более 300 символов' }),
  validateAttainments: z.boolean(),
  applyTaskPriority: z.boolean(),
  applyEmployeeWorkload: z.boolean(),
  applyArrivalTimeOptimization: z.boolean(),
  validateTaskIntervalAndSchedules: z.boolean()
});

export type PlanningAlgorithmFormValues = z.infer<
  typeof PlanningAlgorithmCardSchema
>;

export function getDefaultPlanningAlgorithmForm(): PlanningAlgorithmFormValues {
  return {
    id: '',
    name: '',
    description: '',
    applyTaskPriority: true,
    validateAttainments: true,
    validateTaskIntervalAndSchedules: true,
    applyEmployeeWorkload: true,
    applyArrivalTimeOptimization: true
  };
}
